import { call, put, takeEvery } from 'redux-saga/effects';
import { _CALLPUTAPI } from '../../../api/apiHandler';
import {
  updateUserNotificationConsentStateRequest,
  updateUserNotificationConsentStateSuccess,
  updateUserNotificationConsentStateFailure,
} from './UpdateUserNotificationConsentStateSlice';
import { getLocalSessionData, getUserDataByKey } from '../../../utils/Authentication/handleUserSession';
import { APP, LOCALSESSIONDATAKEYS, WEB, _BROTHER_PLUS_API_ENDPOINTS } from '../../../constants/AppConstants';
import { getDeviceInfoForAddNewDevice } from '../../../constants/AppMethod';
import { consentKeyMap } from '../../../utils/consentService';

function _UPDATEUSERNOTIFICATIONCONSENTSTATE(payload) {
  const endpoint = _BROTHER_PLUS_API_ENDPOINTS.UPDATE_USER_NOTIFICATION_CONSENT_STATE;

  return _CALLPUTAPI(endpoint, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
}

function* updateUserNotificationConsentStateSaga(action) {
  try {
    const userId = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
    const bpId = getUserDataByKey('sapBpId');
    const model = getDeviceInfoForAddNewDevice(LOCALSESSIONDATAKEYS.DEVICE_MODEL) || getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL);
    const deviceId = getDeviceInfoForAddNewDevice(LOCALSESSIONDATAKEYS.DEVICE_ID) || getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
    const serialNumber = getDeviceInfoForAddNewDevice(LOCALSESSIONDATAKEYS.SERIAL_NUMBER) || getLocalSessionData(LOCALSESSIONDATAKEYS.SERIAL_NUMBER);
    const email = getUserDataByKey("emailAddress", 'personal_details')
    
    const { [consentKeyMap[WEB]]: emailConsent, [consentKeyMap[APP]]: inAppConsent } = action.payload ?? {};
   
    const requestPayload = {
      userId,
      sapBpId: bpId,
      email,
      deviceId: deviceId || null,
      serialNumber: serialNumber || null,
      model,
      ...(emailConsent !== undefined && { [consentKeyMap[WEB]]: emailConsent }),
      ...(inAppConsent !== undefined && { [consentKeyMap[APP]]: inAppConsent }),
    };

    const response = yield call(_UPDATEUSERNOTIFICATIONCONSENTSTATE, requestPayload);
    yield put(updateUserNotificationConsentStateSuccess(response));
  } catch (error) {
    yield put(updateUserNotificationConsentStateFailure(error.message));
  }
}

export default function* watchUpdateUserNotificationConsentStateService() {
  yield takeEvery(updateUserNotificationConsentStateRequest.type, updateUserNotificationConsentStateSaga);
}